import ReceiptIcon from '@mui/icons-material/Receipt';
import { OrderList } from './Order.List';
import { OrderCreate } from './Order.Create';
import { OrderEdit } from './Order.Edit';

export default {
    list: OrderList,
    create: OrderCreate,
    edit: OrderEdit,
    icon: ReceiptIcon,
};
